export const boolItems = [
  { label: 'Да', id: 1 },
  { label: 'Нет', id: 0 },
]

export const oneStepRules = {
  load_start_date: {
    required: true,
    message: 'Укажите дату начала погрузки',
    trigger: 'blur',
  },
  org_performer_id: {
    required: true,
    message: 'Укажите исполнителя',
    trigger: 'change',
  },
  is_trawl: {
    required: true,
    message: 'Грузить тралы?',
    trigger: 'blur',
  },
  client: {
    required: true,
    message: 'Выберите заказчика',
    trigger: 'blur',
  },
  load_type_id: {
    required: true,
    message: 'Выберите способ погрузки',
    trigger: 'blur',
  },
  lifting_capacity: {
    type: 'number',
    min: 1,
    required: true,
    trigger: 'blur',
    message: 'Укажите грузоподъемность весов на погрузке',
  },
  distance_libra: {
    type: 'number',
    min: 1,
    required: true,
    trigger: 'blur',
    message: 'Укажите расстояние до весов',
  },
  cars_count: {
    type: 'number',
    min: 1,
    required: true,
    trigger: 'blur',
    message: 'Укажите сколько грузить авто в день',
  },
}

export const secondStepRules = {
  cargo_receiver_name: {
    required: true,
    message: 'Укажите короткое название',
    trigger: 'blur',
  },
  cargo_receiver_legal_name: {
    required: true,
    message: 'Укажите юр. название',
    trigger: 'blur',
  },
  cargo_receiver_address: {
    required: true,
    message: 'Укажите юр. адрес',
    trigger: 'blur',
  },
  distance: {
    type: 'number',
    min: 1,
    required: true,
    trigger: 'blur',
    message: 'Укажите дистанцию',
  },
}

export const thirdStepRules = {
  freight_id: {
    required: true,
    message: 'Выберите тип груза',
    trigger: 'blur',
  },
  weight: {
    type: 'number',
    min: 1,
    required: true,
    trigger: 'blur',
    message: 'Укажите объём перевозки',
  },
  allow_shortage: {
    type: 'number',
    required: true,
    trigger: 'blur',
    message: 'Укажите допустимую недостачу',
  },
  price_from_storage_bidder: {
    type: 'number',
    min: 0.01,
    required: true,
    trigger: 'blur',
    message: 'Укажите цену перевозки',
  },
  price_from_storage_driver: {
    type: 'number',
    min: 0,
    trigger: 'blur',
    message: 'Укажите цену для водителя',
  },
  price_from_field_bidder: {
    type: 'number',
    min: 0.01,
    required: true,
    trigger: 'blur',
    message: 'Укажите цену перевозки',
  },
  price_from_field_driver: {
    type: 'number',
    min: 0,
    trigger: 'blur',
    message: 'Укажите цену для водителя',
  },
}

export const tudatkaParamsFormOne = {
  cars_count: 30, // Сколько грузим в день, авто
  is_trawl: 0, // грузим тралы - нет
  load_type_id: 1, // способ погрузки - не определен
  lifting_capacity: 100, // Грузоподъемность весов на погрузке, т
  distance_libra: 1, // Расстояние до весов, км
}

export const tudatkaParamsFormThree = {
  weight: 1, // Объём перевозки, т
  allow_shortage_is_percents: 1, // Единицы допустимой недостачи - %
  shortage: 0, // Допустимая недостача
  freight_price_per_kg: 0, // Цена товара, руб/тонн
}
